import { h } from 'preact';
import SearchIcon from 'utils/icon/icon-search.svg';
import CloseIcon from 'utils/icon/icon-close.svg';
import { useRef, useState, useEffect } from 'preact/hooks';
import PredictiveSearchForm from '../predictive-search/predictive-search-form';

const SearchBar = ({ onClose }) => {
  const [isSearchActive, setIsSearchActive] = useState(false);
  const searchForm = useRef(null);

  const clickHandle = () => {
    setIsSearchActive(true);
    searchForm.current.querySelector('[name="q"]').focus();
  };

  useEffect(() => {
    const closePredictiveSearch = () => setIsSearchActive(false);
    document.addEventListener('closePredictiveSearch', closePredictiveSearch);
    return () => {
      document.removeEventListener(
        'closePredictiveSearch',
        closePredictiveSearch,
      );
    };
  }, []);

  return (
    <div className="search-bar py-16 px-24 flex gap-26 items-center border-y border-grey-200">
      <button className="relative input-wrapper flex-1" onClick={clickHandle}>
        <div className="absolute z-10 inset-0"></div>
        <SearchIcon className="w-24 h-auto absolute left-16 top-12" />
        <input
          type="text"
          placeholder={window.TMW.Strings.search.label}
          className="body-1 lg:body-2 input !py-12 !pl-48 !pr-72 !border-0 bg-grey-300 placeholder-black placeholder:opacity-100"
        />
      </button>
      <button
        className="w-24 h-24 flex items-center justify-center ml-4 [&>svg]:w-24 [&>svg]:h-24"
        onClick={onClose}
      >
        <CloseIcon />
      </button>
      <div
        ref={searchForm}
        className={`absolute inset-0 h-full w-full bg-white ease-in duration-300
        z-10 -translate-x-full ${isSearchActive ? 'translate-x-0' : ''}`}
      >
        <PredictiveSearchForm />
      </div>
    </div>
  );
};
export default SearchBar;
